// function CalculateScale(){

// }

export const CheckUrlFromStorage = (url) => {
  const CdnDNS = "dhwyjedqg9b7u.cloudfront.net";
  const VideoCdnDNS = "dkw8gemxc9npb.cloudfront.net";
  const ImagesBucketBaseDNS = "pictory-images.s3.us-east-2.amazonaws.com";
  const VideosBucketBaseDNS = "pictory-videos.s3.us-east-2.amazonaws.com";
  const CommonBucketBaseDNS = "brand-settings-images74751-pictorydev";
  const UserBucketBaseDNS = "brand-settings-images130431-pictory";
  const UserDevBucketBaseDNS = "brand-settings-images-dev";
  const DevVideoCdnDNS = "d2p5zbnpdqzqyh.cloudfront.net";

  let bool =
    url.includes(ImagesBucketBaseDNS) ||
    url.includes(VideosBucketBaseDNS) ||
    url.includes(UserBucketBaseDNS) ||
    url.includes(CommonBucketBaseDNS) ||
    url.includes(VideoCdnDNS) ||
    url.includes(CdnDNS) ||
    url.includes(UserDevBucketBaseDNS) ||
    url.includes(DevVideoCdnDNS);

  return bool;
};

export var cache = {};

export const addToCache = (key, item) => {
  cache[key] = item;
};

export const getFromCache = (key) => {
  return cache[key];
};

export const clearCache = () => {
  cache = {};
};

// Do not use media resources proxy server if the resource contains CDN url

const _URL_TO_CDN_ = {
  "brand-settings-images74751-pictorydev.s3.us-east-2.amazonaws.com":
    "dfclq9xt3t3dy.cloudfront.net",
  "brand-settings-images130431-pictory.s3.us-east-2.amazonaws.com":
    "brandsettings-prod.pictorycontent.com",
  "pictory-temp-data.s3.us-east-2.amazonaws.com":
    "temp-data-prod.pictorycontent.com",
  "brand-settings-images-dev-284231530171.s3.us-east-2.amazonaws.com":
    "brand-settings-dev.pictorycontent.com",
  "temp-data-dev-284231530171.s3.us-east-2.amazonaws.com":
    "temp-data-dev.pictorycontent.com",
};

const _CDN_DOMAIN = process.env.REACT_APP_CDN_DOMAIN || "pictorycontent.com";
const _MEDIA_RESOURCES_URL = process.env.REACT_APP_MEDIA_RESOURCES_URL
  ? `${process.env.REACT_APP_MEDIA_RESOURCES_URL}/api/v2`
  : "https://media-resources.pictorycontent.com/api/v2";

const stringToBase64 = str => {
  const bytes = new TextEncoder().encode(str);
  const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join('');
  return btoa(binString);
};

export const getProxyUrl = (url) => {
  // Is this a CDN url?
  if (url.includes(_CDN_DOMAIN)) {
    return url;
  }

  //For s3 urls, replace the bucket url with the corresponding CDN url
  try {
    const parsedUrl = new URL(url);
    const host = parsedUrl.host;
    const cdnHost = _URL_TO_CDN_[host];
    if (cdnHost) {
      const newHost = host.replace(host, cdnHost);
      const newUrl = url.replace(host, newHost);
      return newUrl;
    }
  } catch (e) {
    //TODO: But why?
    console.log(`Failed  to parse url ${url}`, e);
  }

  // Use proxy server for all other urls
  const base64Url = stringToBase64(url);
  return `${_MEDIA_RESOURCES_URL}/proxy-resources?url=${base64Url}&mode=base64`;
};
